import { jsx as _jsx } from "react/jsx-runtime";
const App = () => {
    return (_jsx("div", { children: _jsx("h1", { children: "Hello Friends!! This is an update for end-to-end pipeline testing! and this is to make sure it's working! (Pt4)" }) }));
};
export default App;
